import { useEffect } from 'react'
import { useIntl } from 'react-intl'

// `<title>` in build/index.html is locked to EN at build time. Sync it on
// every locale change so the OS task-switcher / browser tab matches the UI
// language. Renders null — purely side-effectful.
const DocumentTitleSync = (): null => {
  const intl = useIntl()
  useEffect(() => {
    if (typeof document === 'undefined') {
      return
    }
    document.title = intl.formatMessage({ id: 'common.documentTitle' })
  }, [intl])
  return null
}

export default DocumentTitleSync
